import { ContactForm } from "../../components/contact-form/ContactForm";

const App = () => {
  return (
    <div className="w-full">
      <ContactForm />
    </div>
  );
};

export default App;
